import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { StyledTextArea } from '../../../../Components/Generics.styled';
import { StyledButton } from '../../../../Components/Generics.styled';
const DescribeBestCustomerContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const DescribeBestCustomer = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { describeBestCustomer } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (describeBestCustomer !== '') {
            setValue(describeBestCustomer);
        }
    }, [describeBestCustomer]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, describeBestCustomer: value }));
        handleNavButtonNext();
    };
    return (
        <DescribeBestCustomerContainer>
            <StyledTextArea
                label="Describe your best customer?"
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                placeholder="Enter a description about your best customer"
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>{' '}
            </NavButtonContainer>
        </DescribeBestCustomerContainer>
    );
};

DescribeBestCustomer.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

DescribeBestCustomer.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default DescribeBestCustomer;
